import React from 'react';
import '../styles/PrivacyPolicy.css';

// British English comment: Privacy Policy page for Anchor Management
const PrivacyPolicy: React.FC = () => (
  <section className="privacy-policy-section">
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>We value your privacy. This policy explains how we handle your data on this website.</p>
      <h2>Information We Collect</h2>
      <p>We may collect your name, email address, and phone number if you contact us or use our forms.</p>
      <h2>How We Use Your Information</h2>
      <p>Your information is used only to respond to your enquiries and provide our services. We do not share your data with third parties.</p>
      <h2>Contact Us</h2>
      <p>If you have any questions about your privacy, please contact us:</p>
      <ul>
        <li>Phone: +447788 464 155</li>
        <li>Email: keeno1979@yahoo.co.uk</li>
      </ul>
      <h2>Updates</h2>
      <p>This policy may be updated from time to time. Please check back for the latest version.</p>
    </div>
  </section>
);

export default PrivacyPolicy; 